export default "__VITE_ASSET__D3OTSaDf__"